module.exports = __webpack_public_path__ + "img/seamless_reed_basket_pattern.68557ced.jpg";